"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webAuthority = void 0;

var CharacterRangeArbitraryBuilder_1 = require("./_internals/builders/CharacterRangeArbitraryBuilder");

var constant_1 = require("./constant");

var domain_1 = require("./domain");

var ipV4_1 = require("./ipV4");

var ipV4Extended_1 = require("./ipV4Extended");

var ipV6_1 = require("./ipV6");

var nat_1 = require("./nat");

var oneof_1 = require("./oneof");

var option_1 = require("./option");

var stringOf_1 = require("./stringOf");

var tuple_1 = require("./tuple");

var Converters_1 = require("../check/arbitrary/definition/Converters");

function hostUserInfo(size) {
  var others = ['-', '.', '_', '~', '!', '$', '&', "'", '(', ')', '*', '+', ',', ';', '=', ':'];
  return (0, stringOf_1.stringOf)((0, CharacterRangeArbitraryBuilder_1.buildAlphaNumericPercentArbitrary)(others), {
    size: size
  });
}

function userHostPortMapper(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      u = _ref2[0],
      h = _ref2[1],
      p = _ref2[2];

  return (u === null ? '' : "".concat(u, "@")) + h + (p === null ? '' : ":".concat(p));
}

function userHostPortUnmapper(value) {
  if (typeof value !== 'string') {
    throw new Error('Unsupported');
  }

  var atPosition = value.indexOf('@');
  var user = atPosition !== -1 ? value.substring(0, atPosition) : null;
  var portRegex = /:(\d+)$/;
  var m = portRegex.exec(value);
  var port = m !== null ? Number(m[1]) : null;
  var host = m !== null ? value.substring(atPosition + 1, value.length - m[1].length - 1) : value.substring(atPosition + 1);
  return [user, host, port];
}

function bracketedMapper(s) {
  return "[".concat(s, "]");
}

function bracketedUnmapper(value) {
  if (typeof value !== 'string' || value[0] !== '[' || value[value.length - 1] !== ']') {
    throw new Error('Unsupported');
  }

  return value.substring(1, value.length - 1);
}

function webAuthority(constraints) {
  var c = constraints || {};
  var size = c.size;
  var hostnameArbs = [(0, domain_1.domain)({
    size: size
  })].concat(c.withIPv4 === true ? [(0, ipV4_1.ipV4)()] : []).concat(c.withIPv6 === true ? [(0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, ipV6_1.ipV6)()).map(bracketedMapper, bracketedUnmapper))] : []).concat(c.withIPv4Extended === true ? [(0, ipV4Extended_1.ipV4Extended)()] : []);
  return (0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, tuple_1.tuple)(c.withUserInfo === true ? (0, option_1.option)(hostUserInfo(size)) : (0, constant_1.constant)(null), (0, oneof_1.oneof).apply(void 0, _toConsumableArray(hostnameArbs)), c.withPort === true ? (0, option_1.option)((0, nat_1.nat)(65535)) : (0, constant_1.constant)(null))).map(userHostPortMapper, userHostPortUnmapper));
}

exports.webAuthority = webAuthority;